var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.user.role == 'participant' ? _c('div', {
    staticClass: "mr-3",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v(" Available collateral: "), _c('b', [_vm._v(_vm._s(_vm.availableCollateral))])]) : _vm._e(), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a-dropdown', {
    attrs: {
      "trigger": ['click'],
      "placement": "bottomLeft"
    }
  }, [_c('div', {
    class: _vm.$style.dropdown
  }, [_c('a-badge', [_c('a-avatar', {
    class: _vm.$style.avatar,
    attrs: {
      "shape": "square",
      "icon": "user",
      "size": "large"
    }
  })], 1)], 1), _c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('topBar.profileMenu.hello')) + ", " + _vm._s(_vm.user.name || 'Anonymous'))])]), _c('div', [_c('strong', {
    staticClass: "mr-1"
  }, [_vm._v(_vm._s(_vm.$t('topBar.profileMenu.role')) + ":")]), _vm._v(" " + _vm._s(_vm.user.role || '—') + " ")])]), _c('a-menu-divider'), _c('a-menu-item', [_c('a', {
    attrs: {
      "href": "javascript: void(0);"
    },
    on: {
      "click": _vm.myProfile
    }
  }, [_c('i', {
    staticClass: "fe fe-user mr-2"
  }), _vm._v(" " + _vm._s(_vm.$t('topBar.profileMenu.editProfile')) + " ")])]), _c('a-menu-divider'), _c('a-menu-item', [_c('a', {
    attrs: {
      "href": "javascript: void(0);"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fe fe-log-out mr-2"
  }), _vm._v(" " + _vm._s(_vm.$t('topBar.profileMenu.logout')) + " ")])])], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }